import {
  Backdrop,
  Box,
  Card,
  CardHeader,
  CircularProgress,
  Container,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import download from "js-file-download";
import Page from "src/components/Page";
import TransactionTrackingSearchFormComponent from "src/components/forms/TransactionTrackingSearchFormComponent";
import { apiUrl } from "src/Constants";
import { useSelector } from "react-redux";
import Moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function TransactionTrackingComponent() {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const {
    result: { companyid, countryid, secureid },
  } = useSelector((state) => state.loginReducer);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Page className={classes.root} title="Transaction Tracking">
      <Container maxWidth={false}>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For transaction tracking report"
              title="Transaction Tracking"
            />
          </Card>
        </Box>
        <Box>
          <TransactionTrackingSearchFormComponent
            formValue={{
              SECID: secureid,
              BUDGET_YEAR: null,
              COUNTRYID: countryid,
              COMPANYID: companyid,
              DATE_FROM: Moment(`11-01-2020`),
              DATE_TO: Moment(),
              PROJECT_CODE: null,
              BRANDID: "",
              DEPARTID: "",
            }}
            onSubmit={(value) => {
              handleToggle();

              Axios({
                url: `${apiUrl}/report/report-transaction-tracking`,
                method: "POST",
                data: value,
                authorization: `Bearer ${localStorage.getItem("token")}`,
                responseType: "blob",
              })
                .then((res) => {
                  handleClose();
                  const filename =
                    "report-transaction-tracking-" +
                    Moment().format("DD-MMM-YYYY_HHmmss") +
                    ".csv";
                  download(res.data, filename);
                })
                .catch((err) => {
                  handleClose();
                  Swal.fire("The system has error.", err.message, "error");
                });

              // For Excel
              /*
              Axios({
                url: `${apiUrl}/budget-adjustment/report-transaction-tracking`,
                method: "POST",
                data: value,
                authorization: `Bearer ${localStorage.getItem("token")}`,
                responseType: "blob",
              })
                .then((res) => {
                  handleClose();

                  const filename =
                    "report-transaction-tracking-" +
                    Moment().format("DD-MMM-YYYY_HHmmss") +
                    ".xlsx";
                  download(res.data, filename);
                })
                .catch((err) => {
                  handleClose();
                  Swal.fire("The system has error.", err.message, "error");
                });*/
            }}
          />
        </Box>
        <Backdrop
          className={classes.backdrop}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </Page>
  );
}
